export default class FishingRulesService {
  static async getRules(filters = {}) {
    var params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.region) params.append('region', filters.region);
    if (filters.drainage) params.append('drainage', filters.drainage);
    if (filters.water_body_type) params.append('water_body_type', filters.water_body_type);
    if (filters.needs_review) params.append('needs_review', filters.needs_review);
    if (filters.min_confidence) params.append('min_confidence', filters.min_confidence);
    if (filters.sort) params.append('sort', filters.sort);
    if (filters.sort_dir) params.append('sort_dir', filters.sort_dir);
    var query = params.toString();
    var url = '/fishing_rules' + (query ? '?' + query : '');
    return fetch(url, { method: 'GET', headers: { Accept: 'application/json' } }).then(function(r) { return r.json(); });
  }

  static async getRule(id) {
    return fetch('/fishing_rules/' + id, { method: 'GET', headers: { Accept: 'application/json' } }).then(function(r) { return r.json(); });
  }

  static async updateRule(id, data) {
    return fetch('/fishing_rules/' + id, {
      method: 'PUT',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(function(r) { return r.json(); });
  }

  static async triggerParse() {
    return fetch('/fishing_rules/parse', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    }).then(function(r) { return r.json(); });
  }
}
